import React from 'react';
import Calendar from './Calendar';
import LoadingSpinner from 'Utils/LoadingSpinner';
import { withRouter } from 'react-router-dom';

const ItemCalendar = (props) => {
  const {
    highlight,
    datesArray,
    alertingDatesArray,
    loading,
    product,
    productType,
    currentDate,
    endDate,
    history,
    onChangeMonthCallback,
  } = props;
  let date = currentDate ? new Date(currentDate) : new Date();
  let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

  const onSelectDate = (date) => {
    date = date.toISOString().split('T')[0];

    const { token, collectionName } = product;

    history.push(
      `/inventory/calendar?selectedProduct=${token}&selectedDate=${date}&inventoryType=${collectionName}`
    );
  };

  return (
    <div className='calendar'>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Calendar
          highlight={highlight}
          datesArray={datesArray}
          alertingDatesArray={alertingDatesArray}
          productType={productType}
          product={product}
          date={new Date(firstDay.getTime())}
          navigationAllowed
          startDate={date}
          endDate={endDate}
          onSelectDate={onSelectDate}
          withoutPop
          onChangeMonthCallback={onChangeMonthCallback}
        />
      )}
    </div>
  );
};
ItemCalendar.defaultProps = {
  productType: 'items',
};

export default withRouter(ItemCalendar);
